import { isTokenExpired } from "../helpers/TokenHelper";
import createHttpInstance from "./http-common";

class PartnerModel {
    private serviceName = "/partner"

    async GetBecameaPartnerStats(entityTypeId: number) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`${this.serviceName}/GetBecameaPartnerStats?entityTypeId=${entityTypeId}`).catch((err: Error) => {
            throw err?.message;
        })
    }

    async GetBecameaPartnerExport(data: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetBecameaPartnerExport`, data).catch((err: Error) => {
            throw err?.message;
        }
        )
    }

}

export default new PartnerModel()